module.exports = __webpack_public_path__ + "static/media/service5.b5d30aa3.svg";